import './_polyfill_/polyfill'
import {isIE11, isOldEdgeOrIE} from "./_polyfill_/polyfill";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import BrowserUnsupported from "./common/BrowserUnsupported";

ReactDOM.render(
    <React.StrictMode>
        {(isIE11 || isOldEdgeOrIE) && <BrowserUnsupported isIE11 isOldEdgeOrIE/>}
        <App/>
    </React.StrictMode>,
    document.getElementById("root")
);